let Config = {
  TOKEN: "",
  appid: "wxa3ae3231113552da",
  wx_auth_url: `https://open.weixin.qq.com/connect/oauth2/authorize?appid=#{{appid}}&redirect_uri=#{{url}}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`
};

export const practice_icon =
  "https://cdn-xcxcustom.weiyoubot.cn/20200914/ddde099549834d75a4f59e8653e8561e.png";
export const practice_daily_icon =
  "https://cdn-xcxcustom.weiyoubot.cn/20200927/044ac8596272ad1522a590682bb8379a.png";
export const question_icon =
  "https://cdn-xcxcustom.weiyoubot.cn/20201214/c18c9f5a108aa25273ac830ab45ffe6c.png";
export const award_icon =
  "https://cdn-xcxcustom.weiyoubot.cn/20210112/0c3abae86bce25f18b6ac0d5c7c36ebb.png";
export const right_arrow =
  "https://cdn-xcx-qunsou.weiyoubot.cn/material/20220307/768c653e419afe9103dcfab3b14a750a.svg";
export const default_banner =
  "https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-12-27/f132350cfcc96231a4da6c1fed797161.jpg";
export const checkIcon = [
  "https://cdn-xcx-qunsou.weiyoubot.cn/material/20220324/14d75ca253a3b482937158a535cb1db0.svg",
  "https://cdn-xcx-qunsou.weiyoubot.cn/material/20220324/237378fa725325dc1198268f36e5653b.svg"
];
export const df_avatar =
  "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-09-18/a3295cae8d95b5af09a41f4d89d2fb91.jpg";
export const wx_code =
  "https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/3cd24fad2262b8ef5e684b8e2c9759c3.png";

export const complainLists = [
  { title: "权益未生效", value: 0 },
  { title: "支付成功商家未收到钱", value: 1 },
  { title: "莫名被扣费", value: 2 },
  { title: "不满意商家的商品或服务", value: 3 },
  { title: "交易非本人支付", value: 4 },
  { title: "交易被骗", value: 5 },
  { title: "其他问题", value: 6 }
];

export const levelIcon = [
  {
    left:
      "https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-10-17/57f63e069c980d6449c340374bf37250.svg",
    text: "高级版",
    right:
      "https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-10-18/518decbb638f506ee7758659cbafad9f.svg"
  },
  {
    left:
      "https://cdn-xcx-qunsou.weiyoubot.cn/material/20220729/fe4bd735a2236570b534afb04311d3fd.svg",
    text: "基础版",
    right:
      "https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-10-18/f6e7592e167c48e425c4f443bca136b5.svg"
  }
];

export const font_group = ["A标准", "A特大"];
export const font_index = 0;
export const font_rules = {
  do: ["f32", "f48", "f26", "f44", "f30"],
  answer: ["f32", "f48", "f28", "f44", "f32"]
};

export const shareSetting = {
  tabs: [
    {
      title: "分享码",
      type: 0
    },
    {
      title: "分享图",
      type: 1
    },
    {
      title: "H5链接",
      type: 2
    },
    {
      title: "嵌入公众号",
      type: 3
    }
  ],
  tabImgs: [
    "https://cdn-xcxcustom.weiyoubot.cn/20210831/aa07cc99641196b6664872cbbf20db02.png",
    "https://cdn-xcxcustom.weiyoubot.cn/20210831/3700dd11896480141d34c21c0c44b59c.png",
    "https://cdn-xcxcustom.weiyoubot.cn/20201125/b1418b1805b182afda6e108adefd5ac0.png",
    "https://cdn-xcxcustom.weiyoubot.cn/20201125/73da0aa5228a82d1e13fa5480f7b15d4.png"
  ],
  tabBgImgs: [
    "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-09-24/1ddbe8704e3cee3aa3f6d9c779445c5d.png",
    "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-09-24/dc2b3bc256fe22856fe394b4f6e9903e.png",
    "https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-11-03/722f971b0a88b1c6fa35699bd1246cca.png",
    "https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-11-03/9f62ed132d5010da180cb75d36fc970e.png"
  ],
  colorLists: [
    { bg: "#1890FF", checked: 1, rgbColor: "24,144,255" },
    { bg: "#E2453A", rgbColor: "226,69,58" },
    { bg: "#FF8F1F", rgbColor: "255,143,31" },
    { bg: "#00CF97", rgbColor: "0,207,151" },
    { bg: "#000000", rgbColor: "0,0,0" },
    { bg: "#321886", rgbColor: "50,24,134" },
    { bg: "#755ACD", rgbColor: "117,90,205" },
    { bg: "#F19DC1", rgbColor: "241,157,193" },
    { bg: "#ED415D", rgbColor: "237,65,93" },
    { bg: "#FF6165", rgbColor: "255,97,101" },
    { bg: "#811D44", rgbColor: "129,29,68" },
    { bg: "#4AD8D4", rgbColor: "74,216,212" },
    { bg: "#1CBA9F", rgbColor: "28,186,159" },
    { bg: "#95BB2F", rgbColor: "149,187,47" },
    { bg: "#379A3F", rgbColor: "55,154,63" }
  ],
  qrIcon: [
    "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-05-09/882f4f4a8b4c364979612ceba204662f.png",
    "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-05-09/d4481d3807e81b573ce022e5510b4f04.png",
    "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-05-09/ac8efd6ab1cde4c3e4f2b68743e07716.png",
    "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-05-09/faef2c9f7ac756e1c34149078d3894eb.png"
  ],
  selectedIcon:
    "https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-11-10/7982faba3acef72d7d1e6dcf4f6ba277.svg"
};

export const typeIcons = [
  { label: "", icon: "" },
  {
    label: "练习",
    icon:
      "https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-01-02/e54a9f249be8b225fb92032928ab4e7a.svg"
  },
  {
    label: "每日",
    icon:
      "https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-01-02/5e8934f9359b43b49f6cf6e403b4133b.svg"
  },
  {
    label: "问卷",
    icon:
      "https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-01-02/e23baa51fccf1259a6257a275d9663db.svg"
  },
  {
    label: "有奖",
    icon:
      "https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-01-02/bfa7b5ab608bccc8a29a8b12af0a544e.svg"
  },
  { label: "", icon: "" },
  {
    label: "题卡",
    icon:
      "https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-01-02/a4ac5e33b659e5e77dc3f849fd31597c.svg"
  }
];

export default Config;



// WEBPACK FOOTER //
// ./src/utils/config.js